<template>
  <div class="login">
    <div>
      <div class="login__title">Введите ИНН вашей организации</div>
      <div class="login__description">
        Для начала работы введите <br />
        ИНН вашего ИП/ООО.
      </div>
      <double-input
        class="login__input"
        mask="############"
        title="ИНН"
        :has-error="hasInnError || searchInnFailed"
        :error-text="errorInnText"
        @input-changed="checkInn"
      />
      <transition>
        <div v-if="organization.name" class="input__success">
          <div class="input__success-image">
            <img src="../checked.svg" alt="error">
          </div>
          <div class="input__success-text">{{ organization.name }}</div>
        </div>
      </transition>
    </div>
    <div>
      <div v-if="showInnConfirm">
        <div class="login__inn">
          Информация по ИНН <br> найдена верно?
        </div>
        <new-button
          :loading="isLoading"
          title="Да, добавить организацию"
          type="primary"
          width="fullWidth"
          class="inn-accept"
          @button-clicked="saveInn"
        />
        <new-button
          title="Нет, изменить ИНН"
          type="secondary"
          width="fullWidth"
          @button-clicked="resetInn"
        />
      </div>
      <new-button
        v-else
        :loading="isLoading"
        title="Проверить ИНН"
        type="primary"
        width="fullWidth"
        @button-clicked="verifyInn"
      />
    </div>
  </div>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import DoubleInput from './DoubleInput'
import NewButton from '@/components/Drivers/NewButton/NewButton'

const Organization = RepositoryFactory.get('userOrganizations')
const Check = RepositoryFactory.get('check')

export default {
  name: 'AuthUser',
  components: {
    NewButton,
    DoubleInput,
  },
  data() {
    return {
      inn: '',
      organization: {
        name: null,
        id: null,
      },
      isLoading: false,
      hasInnError: false,
      searchInnFailed: false,
      showInnConfirm: false,
    }
  },
  computed: {
    innReady() {
      return (
        (this.inn.length === 10 || this.inn.length === 12) && !this.hasInnError
      )
    },
    errorInnText() {
      if (this.searchInnFailed) {
        return 'Организация не найдена'
      }

      return this.inn.length ? 'Некорректный ИНН' : 'Введите ИНН'
    },
  },
  methods: {
    checkInn(inn) {
      this.inn = inn
      this.searchInnFailed = false
      if (this.inn.length === 10 || this.inn.length === 12) {
        this.hasInnError = false
      } else {
        this.hasInnError = true
      }
    },
    verifyInn() {
      this.checkInn(this.inn)
      if (this.innReady) {
        this.isLoading = true
        Check.inn(this.inn)
          .then(res => {
            this.isLoading = false

            if (res.data) {
              this.organization.name = res.data.short_name
              this.organization.id = res.data.id
              this.showInnConfirm = true
            } else {
              this.searchInnFailed = true
            }
          })
          .catch(() => {})
          .finally(() => (this.isLoading = false))
      }
    },
    saveInn() {
      const data = {
        user_id: this.userInfo.id,
        organization_id: this.organization.id,
      }

      Organization.postItem(data)
        .then(res => {
          if (res.data) {
            this.$store.dispatch(`userProfile/${GET_PROFILE}`)
            this.$router.push({ name: 'Home' })
          }
        })
        .catch(() => {})
    },
    resetInn() {
      this.showInnConfirm = false
      this.organization.name = null
      this.organization.id = null
    },
  },
}
</script>

<style lang="sass" scoped>
.login__input
  margin-top: 3.2rem
.login__inn
  margin-bottom: 2.4rem
  font-size: 1.6rem
  font-weight: 700
  line-height: 2rem
  text-align: center
  color: #5C5C5C
.inn-accept
  margin-bottom: 1.6rem
.input__success
  display: flex
  align-items: center
  padding-top: .8rem

  &-image
    width: 1.6rem
    height: 1.6rem
    margin-right: 0.9rem

    img
      width: 100%
      height: 100%
  &-text
    font-size: 1.4rem
    color: #5C5C5C
</style>
